export default __webpack_public_path__ + "static/media/irInActive.755cd0bb.svg";